import HTTPExceptionInterceptor from '@shared/modules/http/domain/services/HTTPExceptionInterceptor'

import { HTTPDatasource } from '@/modules/auth/infra/datasource/HTTPDatasource'
import { API_URL } from '@/modules/shared/constants/API_URL'

export const FetchAdapter: HTTPDatasource = {
  async get<Data>(path: string, options?: RequestInit): Promise<Data> {
    const response = await HTTPExceptionInterceptor(
      await fetch(`${API_URL}${path}`, {
        ...options,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...options?.headers
        }
      })
    )
    return (await response.json()) as Data
  },

  async post<Data>(
    path: string,
    payload?: object,
    options?: RequestInit
  ): Promise<Data> {
    const response = await HTTPExceptionInterceptor(
      await fetch(`${API_URL}${path}`, {
        ...options,
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          ...options?.headers
        }
      })
    )
    return (await response.json()) as Data
  },

  async put<Data>(
    path: string,
    payload?: object,
    options?: RequestInit
  ): Promise<Data | void> {
    const response = await HTTPExceptionInterceptor(
      await fetch(`${API_URL}${path}`, {
        ...options,
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          ...options?.headers
        }
      })
    )
    const contentType = response.headers.get('content-type')
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return (await response.json()) as Data
    }
  },

  async patch<Data>(
    path: string,
    payload?: object,
    options?: RequestInit
  ): Promise<Data> {
    const response = await HTTPExceptionInterceptor(
      await fetch(`${API_URL}${path}`, {
        ...options,
        method: 'PATCH',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          ...options?.headers
        }
      })
    )
    return (await response.json()) as Data
  },

  async delete<Data>(path: string, options?: RequestInit): Promise<Data> {
    const response = await HTTPExceptionInterceptor(
      await fetch(`${API_URL}${path}`, {
        ...options,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          ...options?.headers
        }
      })
    )
    return (await response.json()) as Data
  }
}
